import React from 'react';
import clsx from 'clsx';
import MajorViewCard from '../card';
import style from './style.module.scss';
import SoccerView from '../../../soccer/view';
import BaseballView from '../../../baseball/view';
import BasketballView from '../../../basketball/view';
import VolleyballView from '../../../volleyball/view';
import HockeyView from '../../../hockey/view';

const MajorViewSlider = ({
  list,
  majorSelected,
  setSelectedGame,
  viewType
}) => {
  if (viewType === 'DEFAULT_VIEW') {
    return (
      <div className={clsx(style.sportsSlider, style.default)}>
        {list.length > 0 &&
          list.map((item) => {
            if (item.sportsType === 'SOCCER') {
              return (
                <SoccerView
                  item={item}
                  key={item.id}
                  isSelected={majorSelected
                    .filter((sel) =>
                      (sel.sportsType === item.sportsType.toLowerCase()) ===
                      'icehockey'
                        ? 'hockey'
                        : item.sportsType.toLowerCase()
                    )
                    .some((id) => id.key === item.id)}
                  setSelectedGame={(
                    isSelected,
                    id,
                    originStartDateTime,
                    gameStatus
                  ) =>
                    setSelectedGame(
                      isSelected,
                      id,
                      originStartDateTime,
                      gameStatus,
                      'SOCCER'
                    )
                  }
                />
              );
            } else if (item.sportsType === 'BASEBALL') {
              return (
                <BaseballView
                  item={item}
                  key={item.id}
                  isSelected={majorSelected
                    .filter((sel) =>
                      (sel.sportsType === item.sportsType.toLowerCase()) ===
                      'icehockey'
                        ? 'hockey'
                        : item.sportsType.toLowerCase()
                    )
                    .some((id) => id.key === item.id)}
                  setSelectedGame={(
                    isSelected,
                    id,
                    originStartDateTime,
                    gameStatus
                  ) =>
                    setSelectedGame(
                      isSelected,
                      id,
                      originStartDateTime,
                      gameStatus,
                      'BASEBALL'
                    )
                  }
                />
              );
            } else if (item.sportsType === 'BASKETBALL') {
              return (
                <BasketballView
                  item={item}
                  key={item.id}
                  isSelected={majorSelected
                    .filter((sel) =>
                      (sel.sportsType === item.sportsType.toLowerCase()) ===
                      'icehockey'
                        ? 'hockey'
                        : item.sportsType.toLowerCase()
                    )
                    .some((id) => id.key === item.id)}
                  setSelectedGame={(
                    isSelected,
                    id,
                    originStartDateTime,
                    gameStatus
                  ) =>
                    setSelectedGame(
                      isSelected,
                      id,
                      originStartDateTime,
                      gameStatus,
                      'BASKETBALL'
                    )
                  }
                />
              );
            } else if (item.sportsType === 'VOLLEYBALL') {
              return (
                <VolleyballView
                  item={item}
                  key={item.id}
                  isSelected={majorSelected
                    .filter((sel) =>
                      (sel.sportsType === item.sportsType.toLowerCase()) ===
                      'icehockey'
                        ? 'hockey'
                        : item.sportsType.toLowerCase()
                    )
                    .some((id) => id.key === item.id)}
                  setSelectedGame={(
                    isSelected,
                    id,
                    originStartDateTime,
                    gameStatus
                  ) =>
                    setSelectedGame(
                      isSelected,
                      id,
                      originStartDateTime,
                      gameStatus,
                      'VOLLEYBALL'
                    )
                  }
                />
              );
            } else if (item.sportsType === 'ICEHOCKEY') {
              return (
                <HockeyView
                  item={item}
                  key={item.id}
                  isSelected={majorSelected
                    .filter((sel) =>
                      (sel.sportsType === item.sportsType.toLowerCase()) ===
                      'icehockey'
                        ? 'hockey'
                        : item.sportsType.toLowerCase()
                    )
                    .some((id) => id.key === item.id)}
                  setSelectedGame={(
                    isSelected,
                    id,
                    originStartDateTime,
                    gameStatus
                  ) =>
                    setSelectedGame(
                      isSelected,
                      id,
                      originStartDateTime,
                      gameStatus,
                      'ICEHOCKEY'
                    )
                  }
                />
              );
            } else {
              return null;
            }
          })}
      </div>
    );
  } else {
    return (
      <div className={style.sportsSlider}>
        {list.length > 0 &&
          list.map((item) => {
            return (
              <MajorViewCard
                item={item}
                key={item.id}
                isSelected={majorSelected
                  .filter((sel) =>
                    (sel.sportsType === item.sportsType.toLowerCase()) ===
                    'icehockey'
                      ? 'hockey'
                      : item.sportsType.toLowerCase()
                  )
                  .some((id) => id.key === item.id)}
                setSelectedGame={setSelectedGame}
              />
            );
          })}
      </div>
    );
  }
};

export default MajorViewSlider;
